import { render } from "./CardLink.vue?vue&type=template&id=3d165bbe&scoped=true"
import script from "./CardLink.vue?vue&type=script&lang=ts"
export * from "./CardLink.vue?vue&type=script&lang=ts"

import "./CardLink.vue?vue&type=style&index=0&id=3d165bbe&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-3d165bbe"

export default script